
define('text!TescoMobile_Checkout/template/form/element/find-address-link.html',[],function () { return '<div class="field find-address field-link"><a data-bind="text: \'Find address\', click: findAddress"></a></div><!-- ko if: requestError() --><div class="lookup field-error"><span data-bind="i18n: \'Please lookup your address.\'"></span></div><!-- /ko -->';});

